var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schemem"},[_c('div',{staticClass:"scheme_inner"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"img_box"}),_c('h2',[_vm._t("title")],2),_c('div',{staticClass:"img_box"})]),_c('div',{staticClass:"sub_title"},[_vm._t("subTitle")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }